import { store } from '@src/state/store';
import { pushEventQueue } from '@src/state/slices/slice_game';

export default () => (data: any) => {
  if (!data || !data.msg) return;

  console.error(data);

  store.dispatch(
    pushEventQueue({
      message: 'ERROR: ' + data.msg,
      showToast: true,
      sound: 'error',
    }),
  );
};
